module.exports = __webpack_public_path__ + "img/ico-off.18e8a0a4.svg";